import React from 'react'
import {  Box} from '@mui/material'
import { DataGrid} from '@mui/x-data-grid';

// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };
const dataGridStyle = {
    root: {
      "& .MuiDataGrid-root": {
        borderRadius: '10px',
        backgroundColor: 'white',
        fontSize: '15px',
      },
      "& .MuiDataGrid-columnHeaders": {
        color: '#005A9C',
        fontSize: '16px',
      }
    },
};

// function CustomColumnMenu(props) {
//     return (
      
//       <GridColumnMenu
//         {...props}
//         slots={{
//        // Hide `columnMenuColumnsItem`
//         columnMenuColumnsItem: null,
//         columnMenuSortItem: null,
//         }}
//       />
      
//   );
//   }
const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false, flex: 1, minWidth: 100 , },
    { field: 'Parts_Code', headerName: 'Parts Code', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Part_Descrption', headerName: 'Part Descrption', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Qty', headerName: 'Qty', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Price', headerName: 'Price', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Net_Amount', headerName: 'Net Amount', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'VAT', headerName: 'VAT%', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Vat_Amount', headerName: 'Vat Amount', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Total_Amount', headerName: 'Total_Amount', editable: false, sortable: false, flex: 1 , minWidth: 100},  
]

const rows = [
    { id: '1', Parts_Code: '', Part_Descrption: '', Qty: '', Price:'', Net_Amount:'', VAT:'', Vat_Amount: '', Total_Amount:''},
    { id: '2', Parts_Code: '', Part_Descrption: '', Qty: '', Price:'', Net_Amount:'', VAT:'', Vat_Amount: '', Total_Amount:''},
    { id: '3', Parts_Code: '', Part_Descrption: '', Qty: '', Price:'', Net_Amount:'', VAT:'', Vat_Amount: '', Total_Amount:''},
    { id: '4', Parts_Code: '', Part_Descrption: '', Qty: '', Price:'', Net_Amount:'', VAT:'', Vat_Amount: '', Total_Amount:''},
    ];    


function InvoiceParts() {
  return (
    <Box sx={dataGridStyle.root}>
            <DataGrid
                columnHeaderHeight={25}
                 rowHeight={25}
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
            />
        </Box>

    )
}

export default InvoiceParts